import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

function RelationEmp() {
  return (
    <SettingsMetaData propertyName={"Relation_emp"} viewPropertyName={"Relationship"} />
)
}

export default RelationEmp